module.exports = __webpack_public_path__ + "img/Recommend_yqkk.8d50be3d.png";